import { ApiInstance } from '@src/services/api-instance';

import { LutienAuthService } from './auth/lutien-auth';
import { LutienOrganizationsService } from './organizations/lutien-organizations';
import { LutienUsersService } from './users/lutien-users';

export class LutienV1Service {
  private readonly client: ApiInstance;

  public auth: LutienAuthService;
  public organizations: LutienOrganizationsService;
  public users: LutienUsersService;

  constructor(client: ApiInstance) {
    this.client = new ApiInstance(`${client.getBaseUrl()}/v1`, client.getTimeout());

    this.auth = new LutienAuthService(this.client);
    this.organizations = new LutienOrganizationsService(this.client);
    this.users = new LutienUsersService(this.client);
  }
}
